import { diffLines } from "diff";

const create_element = (part, value) => {
  let diff_color = null;
  let element = null;

  diff_color = part.added ? "#E03D3C" : part.removed ? "#627081" : "#3EB160";

  element = document.createElement("span");
  element.style.color = diff_color;
  element.style.whiteSpace = "pre-wrap";
  element.appendChild(document.createTextNode(value));

  return element;
};

export const data_entry_view = (data_entry_data) => {
  let totalCountKeystrokes = 0;
  let dataFieldsWithError = 0;
  let dataFieldsCompleted = 0;
  let dataEntryResults = [];
  let dataEntryErrors = [];

  let fragment = document.createDocumentFragment();
  let element = null;
  let div = null;
  div = document.createElement("div");

  let lastFormWithInput = -1;

  data_entry_data.forEach((form, form_index) => {
    // Keep track of the last form
    const isLastForm = form_index === data_entry_data.length - 1;
    if (isLastForm) {
      for (let i = 0; i < form.length; i++) {
        if (form[i].hasOwnProperty("input") && form[i].input !== "") {
          lastFormWithInput = i;
        }
      }
    }

    let dataEntryForm = [];

    // get the last form)
    form.forEach((formItem, formItem_index) => {
      let dataEntryField = {};
      let dataEntryError = {};

      if ("input" in formItem && formItem.input !== "") {
        const referenceText = formItem.value;
        const inputText = formItem.input.trim();
        // Calculate total count of characters typed
        totalCountKeystrokes += inputText.length;

        const diffs = diffLines(referenceText, inputText, {
          ignoreWhitespace: true,
        });

        if (lastFormWithInput !== formItem_index) {
          diffs.forEach((part) => {
            if (part.added || part.removed) {
              if (part.added) {
                element = create_element(part, part.value);
                fragment.appendChild(element);
                dataFieldsWithError += 1;
                dataEntryError["reference_value"] = formItem.value;
                dataEntryError["error_value"] = part.value;
                dataEntryErrors.push(dataEntryError);
              }
            } else {
              element = create_element(part, part.value);
              fragment.appendChild(element);
            }
          });
          dataFieldsCompleted += 1;
        } else {
          diffs.forEach((part) => {
            if (part.added || part.removed) {
              if (part.added) {
                if (inputText.length >= referenceText.length) {
                  element = create_element(part, part.value);
                  fragment.appendChild(element);
                  dataFieldsWithError += 1;
                  dataEntryError["reference_value"] = formItem.value;
                  dataEntryError["error_value"] = part.value;
                  dataEntryErrors.push(dataEntryError);
                  dataFieldsCompleted += 1;
                } else {
                  element = document.createElement("span");
                  element.style.whiteSpace = "pre-wrap";
                  element.appendChild(document.createTextNode(part.value));
                  fragment.appendChild(element);
                }
              }
            } else {
              element = create_element(part, part.value);
              fragment.appendChild(element);
              dataFieldsCompleted += 1;
            }
          });
        }
        div = document.createElement("div");
        div.appendChild(fragment);
        dataEntryField["input"] = div.innerHTML;
      } else {
        dataEntryField["input"] = "";
      }

      dataEntryField["fieldname"] = formItem.fieldname;
      dataEntryField["value"] = formItem.value;
      dataEntryForm.push(dataEntryField);
    });
    dataEntryResults.push(dataEntryForm);
  });

  return {
    totalCountKeystrokes,
    dataFieldsWithError,
    dataFieldsCompleted,
    dataEntryResults,
    dataEntryErrors,
  };
};
